













































































































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import { Loading } from "element-ui";
import { post, get } from "@/utils/ajax";
@Component
export default class Goods extends Vue {
  @Prop() private couponsInfo!: any;
  @Prop() private setCoupons!: (couponsId: string, name: string) => void;
  @Prop() private closeDialog!: () => void;

  public data() {
    return {
      isCoupons: null,
      isLoading: false,

      title: "",
      couponId: undefined,
      total: 0,
      list: [],
      page_num: 1,
      page_size: 20,
    };
  }
  public mounted() {
    this.queryList(1);
    this.$data.isCoupons = this.couponsInfo.couponsId;
  }

  // 获取优惠券
  public async queryList(num: any) {
    this.$data.isLoading = true;
    this.$data.page_num = num || 1;
    try {
      const params: any = {
        page: this.$data.page_num,
        page_size: this.$data.page_size,
        name: this.$data.title,
        coupon_id: this.$data.couponId,
        activity_id: 14,
      };
      const data = await get("/admin/basic/jd/coupon-list", params);
      this.$data.list = data.list;
      this.$data.total = data.total;
    } catch (error) {
      this.$data.list = [];
      this.$data.total = 0;
      this.$data.page_num = 1;
      (this as any).$message.error(error.msg || error.message || error);
    }
    this.$data.isLoading = false;
  }

  // 选择优惠券
  public async pushItem(item: any) {
    this.$data.isLoading = true;
    if (item.lockType == 1 && item.grantType == 5) {
      try {
        await get("/admin/basic/jd/lock-coupon", {
          activity_id: 14,
          coupon_id: item.couponId,
        });
        this.$data.isLoading = false;
        this.setCoupons(item.couponId, item.name);
        this.closeGoods();
      } catch (error) {
        (this as any).$message.error(error.msg || error.message || error);
      }
    } else {
      this.$data.isLoading = false;
      this.setCoupons(item.couponId, item.name);
      this.closeGoods();
    }
  }

  public syncGoods() {
    this.$confirm(
      "同步优惠券可能会是一个长耗时的操作，再同步过程中尽量不要进行任何操作?",
      {
        title: "商品优惠券提醒",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(async () => {
        this.$data.isLoading = true;
        // await get("/admin/basic/jd/sync-items", { activity_id: 14 });
        await this.queryList(1);
      })
      .catch((error) => {
        console.log("错误", error);
      });
    this.$data.isLoading = false;
  }

  // 关闭弹窗
  public async closeGoods() {
    this.closeDialog();
  }
}
